import React from 'react';
import { Link, graphql } from 'gatsby';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const Services = (props) => {
  const services = props.data.allMarkdownRemark.edges;
  return (
    <Layout bodyClass="page-services">
      <SEO title="Wild Bees" />
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Wild Honeybees</h1>
              <p>As honeybees are not native to north america, honeybees living in the wild are descendants of bees that escaped from kept hives, they are called feral.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container pb-6">
        <div className="row">
          {services.map(edge => (
            <div key={edge.node.frontmatter.path} className="col-12 col-md-2 mb-1">
              <div className="card service service-teaser">
                <div className="card-content">
                  <h2>
                    <Link to={edge.node.frontmatter.path}>{edge.node.frontmatter.title}</Link>
                  </h2>
                  <p dangerouslySetInnerHTML={{__html: edge.node.excerpt}}></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query ServicesQuery {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/\\/bees\\//" }, frontmatter: {draft: {eq: false}} }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt(format: HTML)
          frontmatter {
            title
            path
          }
        }
      }
    }
  }
`;

export default Services;
